export var Family;
(function (Family) {
    Family["filter"] = "FILTER";
    Family["listType"] = "LIST_TYPE";
    Family["shortcuts"] = "SHORTCUTS";
})(Family || (Family = {}));
